<template>
  <modal
    name="cameraModal"
    :width="640"
    :height="480"
    :click-to-close="false"
  >
    <div class="cameraModalMain">
      <div class="titleRow" :style="{ backgroundColor: $config.theme.default.previewPage.topBarColor} ">
        <div
          class="closeBtn"
          @click="closeModal"
        >
          <img src="@/assets/images/close2.png">
        </div>
        <div class="title">
          Fotoğraf Çek
        </div>
      </div>
      <!-- Camera sensor -->
      <canvas id="camera--sensor" />
      <!-- Camera view -->
      <video
        id="camera--view"
        autoplay
        playsinline
      />
      <!-- Camera output -->
      <img
        src="//:0"
        alt=""
        id="camera--output"
      >

      <button
        id="camera--trigger"
        @click="cameraTriggerClicked"
      >
        Fotoğraf çek
      </button>
    </div>
  </modal>
</template>

<script>
import EventBus from '@/eventbus.js'

var constraints = {
  video: {
    facingMode: 'user'
  },
  audio: false
}
var cameraView, cameraOutput, cameraSensor, track

var takePhotoVue

export default {
  methods: {
    closeModal () {
      track.stop()
      this.$modal.hide('cameraModal')
    },
    takePhoto () {
      setTimeout(function () {
        cameraView = document.querySelector('#camera--view')
        cameraOutput = document.querySelector('#camera--output')
        cameraSensor = document.querySelector('#camera--sensor')
        takePhotoVue.cameraStart()
      }, 1000)
    },
    cameraStart () {
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          track = stream.getTracks()[0]

          cameraView.srcObject = stream
        })
        .catch(function (error) {
          console.error('Oops. Something is broken.', error)
        })
    },

    cameraTriggerClicked () {
      cameraSensor.width = cameraView.videoWidth
      cameraSensor.height = cameraView.videoHeight
      cameraSensor.getContext('2d').drawImage(cameraView, 2, 2)
      cameraOutput.src = cameraSensor.toDataURL('image/jpeg', 1.0)
      this.$store.commit('setProfilePhoto', cameraOutput.src)
      cameraOutput.classList.add('taken')
      track.stop()
    }
  },

  mounted () {
    EventBus.$on('takePhoto', this.takePhoto)
  },

  created () {
    takePhotoVue = this
  }
}
</script>

<style scoped>
.cameraModalMain {
  width: calc(100% - 0px);
  height: calc(100% - 0px);
}

.titleRow {
  text-align: center;
  padding: 10px;
  background-color: #1a9bfc;
  color: white;
  font-weight: 700;
  display: flex;
}
.closeBtn {
  flex-grow: 0;
  cursor: pointer;
}

.closeBtn > img {
  width: 15px;
}

.title {
  flex-grow: 1;
}

#camera--sensor,
#camera--output {
  position: fixed;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

#camera--view {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#camera--sensor {
  opacity: 0;
}

#camera--view,
#camera--sensor,
#camera--output {
  transform: scaleX(-1);
  filter: FlipH;
}

#camera--trigger {
  width: 200px;
  background-color: black;
  color: white;
  font-size: 16px;
  border-radius: 30px;
  border: none;
  padding: 15px 20px;
  text-align: center;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 30px;
  left: calc(50% - 100px);
}

.taken {
  height: 100px !important;
  width: 100px !important;
  transition: all 0.5s ease-in;
  border: solid 3px white;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
  top: 20px;
  right: 20px;
  z-index: 2;
}
</style>

<style>
.v--modal-overlay {
  background-color: RGBA(0, 0, 0, 0.8);
}
</style>
